export function isSuperAdmin(): boolean {
  const userData = sessionStorage.getItem('current_user');
  if (userData === null) {
    return false;
  }
  const superAdmin = JSON.parse(userData).superAdminMode;
  return superAdmin;
}
